import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from '@angular/core';
import { MomentModule } from 'ngx-moment';
import { KeyValuePairComponent } from 'src/app/shared/general/key-value-pair/key-value-pair.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { DeliveryJobForUser } from 'src/app/shared/services/user-jobs.service';
import { DeliveryItemsListPipe } from '../delivery-items-list.pipe';
import { GoogleMapsLinkComponent } from 'src/app/shared/general/google-maps-link/google-maps-link.component';
import { TitleCasePipe } from '@angular/common';
@Component({
  selector: 'app-compact-delivery-job',
  standalone: true,
  templateUrl: './compact-delivery-job.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    KeyValuePairComponent,
    DeliveryItemsListPipe,
    MomentModule,
    GoogleMapsLinkComponent,
    TitleCasePipe
  ]
})
export class CompactDeliveryJobComponent {
  dateFormat = ConfigService.dates.shortDateTimeFormat;
  job = input.required<DeliveryJobForUser>();
  showJobDetails = output<DeliveryJobForUser>();

  overdue = computed(() => new Date(this.job().due) < new Date());
}
